<template>
  <div class="hs-hero">
    <div class="left">
      <span v-for="item in navList"
            :key="item.href">
        <a v-if="item.href.startsWith('http')"
           :href="item.href"
           target="_blank"
           class="nav-btn">
          {{ item.label }}
        </a>
        <router-link v-else
                     class="nav-btn"
                     :to="item.href">
          {{ item.label }}
        </router-link>
      </span>
    </div>

    <div class="center">
      <p class="hs-sub">
        {{ homeInfo?.homeContent?.title1 }}
      </p>

      <div class="hs-social"
           aria-label="Social links">
        <a v-for="(item, index) in homeInfo?.homeContent?.links"
           :key="index"
           class="hs-social-link"
           :href="item.linkAddress"
           target="_blank"
           rel="noopener noreferrer">
          <span class="hs-ico"
                v-html="item.url" />
        </a>
      </div>
    </div>

    <!-- 代购平台选择 -->
    <SelectPurchasingPlatform v-show="(!state.isMobile && homeInfo.showPlatform == 'Y') || (state.isMobile && homeInfo.mobileShowPlatform == 'Y')"
                              :expert="expertConfig.expert"
                              @handleChangeExpert="handleChangeExpert" />

    <div class="right">
      <el-button class="icon-btn"
                 type="button"
                 aria-label="Search"
                 @click="dialogVisible = true">
        <i class="el-icon-search"></i>
      </el-button>
    </div>

    <el-dialog :visible.sync="dialogVisible"
               width="40%"
               :show-close="false"
               :lock-scroll="false">
      <el-input v-model="state.searchValue"
                class="search-input--image"
                clearable
                prefix-icon="el-icon-search"
                placeholder="Search"
                autocomplete="off"
                @keyup.enter.native="goGoodsSearch">
        <template #append>
          <ImageSearchBtn />
        </template>
      </el-input>
    </el-dialog>
  </div>
</template>

<script>
import SelectPurchasingPlatform from '@/components/selectPurchasingPlatform.vue'
import ImageSearchBtn from '@/components/ImageSearchBtn.vue'

export default {

  name: 'PageHeader',

  components: {
    SelectPurchasingPlatform,
    ImageSearchBtn,
  },

  props: {
    homeInfo: {
      type: Object,
      default: () => ({}),
    },
    expertConfig: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      dialogVisible: false,
      state: {
        platform: {},
        searchValue: '',
        isMobile: window.innerWidth < 768,
      },
    }
  },

  computed: {
    navList() {
      const arr = [
        { href: '/home', label: 'HOME' },
        { href: '/goods', label: 'PRODUCTS' }
      ]

      if (this.homeInfo?.excelUrl) {
        arr.push({ href: this.homeInfo?.excelUrl, label: 'SPREADSHEET' })
      }

      return arr
    },
  },

  methods: {
    handleChangeExpert(platform) {
      this.state.platform = platform
      this.$emit('handleChangeExpert', platform)
    },
    /**
     * 回车：带关键词跳转商品页（query.keyword 与商品页搜索框同步）
     */
    goGoodsSearch() {
      const raw = this.state.searchValue
      const keyword = (typeof raw === 'string' ? raw : String(raw ?? '')).trim()
      if (keyword.length <= 0) {
        return
      }
      this.dialogVisible = false
      this.$router.push({
        path: '/goods',
        query: { keyword },
      })
    },
  },
}
</script>

<style scoped lang="scss">
@import '../assets/home-type3-content.scss';

.nav-btn:hover {
  color: var(--primary-color) !important;
}

.el-icon-search,
.hs-ico {
  color: var(--primary-color);
}

.hs-hero {
  position: relative;
  padding-top: 28px;

  .left,
  .right {
    position: absolute;
    top: 0;
    display: flex;
    align-items: center;
  }

  .left {
    left: 16px;
    gap: 16px;
  }

  .right {
    top: 5px;
    right: 16px;
  }

  .nav-btn {
    color: var(--select-color) !important;
    font-size: 14px;
    font-weight: 700;
    text-decoration: none;
    letter-spacing: 0.02em;
  }

  .nav-btn:hover {
    color: var(--primary-color) !important;
  }

  .icon-btn {
    border: 0;
    background: transparent;
    color: #000;
    padding: 0;
    cursor: pointer;
    font-size: 18px;
    line-height: 1;
    outline: none;
  }

  .nav-btn:hover,
  .icon-btn:hover {
    opacity: 0.72;
  }

  .center {
    display: flex;
    justify-content: center;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 10px;
  }

  :deep(.el-dialog) {
    border-radius: 8px;

    .el-dialog__header {
      padding: 0;
    }
  }

  :deep(.el-input__inner) {
    color: var(--select-color);
    border: 1px solid hsl(from var(--select-border-color) h s l / 0.8) !important;
    background-color: hsl(from var(--select-border-color) h s l / 0.5);
  }

  @media (max-width: 768px) {
    :deep(.el-dialog) {
      width: 95% !important;
    }
  }
}
</style>